import { render, staticRenderFns } from "./role-manage-log.vue?vue&type=template&id=195b3620&scoped=true&"
import script from "./role-manage-log.vue?vue&type=script&lang=js&"
export * from "./role-manage-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b3620",
  null
  
)

export default component.exports